import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import "../styles/navStyles.css";
import "../styles/masterStyles.css";

const Foot = props => {
    const [value, setValue] = React.useState(0);

    const footerIcon = icon => {
        switch (icon) {
            case "settings":
                return (
                    <BottomNavigationAction
                        label="Settings"
                        icon={<SettingsIcon />}
                        to="/settings"
                        component={NavLink}
                    />
                );
            case "profile":
                return (
                    <BottomNavigationAction
                        label="Profile"
                        icon={<EmojiEventsIcon />}
                        to="/profile"
                        component={NavLink}
                    />
                );
            default:
                return (
                    <BottomNavigationAction
                        label="Home"
                        icon={<HomeIcon />}
                        to="/home"
                        component={NavLink}
                    />
                );
        }
    };
    
    if (props.auth) {
        const { footerOne, footerTwo, footerThree } = props;
        return (
            <BottomNavigation
                className="footer"
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
                showLabels
                id="MainFooter"
            >
                {footerIcon('home')}
                {footerIcon('settings')}
                {footerIcon('profile')}
            </BottomNavigation>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    const { footerOne, footerTwo, footerThree } = state.data;
    return { auth, user_details, footerOne, footerTwo, footerThree };
};

const Footer = connect(mapStateToProps)(Foot);

export { Footer };
